import {
    CHANGE_COUNTRY,
    CHANGE_CURRICULUM_TYPE,
    CHANGE_DOCUMENT,
    CHANGE_PRODUCT,
    CHANGE_PUBLICATION,
    CHANGE_SECTION,
    CHANGE_STATE,
    GET_COUNTRIES_FAILURE,
    GET_COUNTRIES_REQUEST,
    GET_COUNTRIES_SUCCESS,
    GET_DOCUMENTS_BY_PUBLICATION_FAILURE,
    GET_DOCUMENTS_BY_PUBLICATION_REQUEST,
    GET_DOCUMENTS_BY_PUBLICATION_SUCCESS,
    GET_SECTION_DETAIL_BY_ID_FAILURE,
    GET_SECTION_DETAIL_BY_ID_REQUEST,
    GET_SECTION_DETAIL_BY_ID_SUCCESS,
    GET_SECTIONS_BY_DOCUMENT_FAILURE,
    GET_SECTIONS_BY_DOCUMENT_REQUEST,
    GET_SECTIONS_BY_DOCUMENT_SUCCESS,
    GET_STATES_BY_COUNTRY_FAILURE,
    GET_STATES_BY_COUNTRY_REQUEST,
    GET_STATES_BY_COUNTRY_SUCCESS,
    LOAD_SECTION_LIST,
    REGISTER_MASTER_COURSE_FAILURE,
    REGISTER_MASTER_COURSE_REQUEST,
    REGISTER_MASTER_COURSE_SUCCESS,
    UPDATE_TREE_DATA,
    GET_PUBLICATIONS_SUCCESS,
    UPDATE_PUBLICATIONS
} from './actions';

import {
    CHECK_SECTION_FILE_REQUEST,
    CHECK_SECTION_FILE_SUCCESS,
    CHECK_SECTION_FILE_FAILURE,
    DELETE_SECTION_FILE_REQUEST,
    DELETE_SECTION_FILE_FAILURE,
    DELETE_SECTION_FILE_SUCCESS,
    UPLOAD_SECTION_FILE_REQUEST,
    UPLOAD_SECTION_FILE_SUCCESS
} from '../curriculum-documents/actions';

import { DEFAULT_DROPDOWN_ID_INT } from '../../constants';

import {
    modifyCollection,
    convertToTreeData,
    getCurriculumAlignmentDocuments
} from './helpers';

const initState = {
    countries: [],
    countryLoaded: false,
    currentView: 'sectionList',
    curriculumAlignmentDocuments: {},
    curriculumType: '',
    disableRegisterCourseButton: false,
    documents: [],
    isRequesting: false,
    isUploadingFile: false,
    publications: [],
    sections: [],
    selectedCountry: '',
    selectedDocument: '',
    selectedProductId: DEFAULT_DROPDOWN_ID_INT,
    selectedPublication: '',
    selectedSection: '',
    selectedSectionDetail: {},
    selectedState: '',
    states: []
};

export default function (state = initState, action) {
    switch (action.type) {
    case GET_COUNTRIES_REQUEST: {
        return { ...state };
    }
    case GET_COUNTRIES_SUCCESS: {
        return {
            ...state,
            countries: action.data,
            countryLoaded: true
        };
    }
    case GET_COUNTRIES_FAILURE: {
        return {
            ...state,
            countryLoaded: false
        };
    }
    case CHANGE_COUNTRY: {
        return {
            ...state,
            selectedCountry: action.countryCode,
            selectedPublication: '',
            selectedSection: '',
            selectedProductId: DEFAULT_DROPDOWN_ID_INT,
            curriculumAlignmentDocuments: {},
            documents: [],
            countries: modifyCollection(state.countries, 'key', action.countryCode),
            selectedState: '',
            currentView: 'sectionList'
        };
    }
    case GET_DOCUMENTS_BY_PUBLICATION_REQUEST:
    case GET_DOCUMENTS_BY_PUBLICATION_FAILURE: {
        return {
            ...state,
            documents: []
        };
    }
    case GET_DOCUMENTS_BY_PUBLICATION_SUCCESS: {
        return {
            ...state,
            documents: action.data
        };
    }
    case GET_SECTIONS_BY_DOCUMENT_REQUEST:
    case GET_SECTIONS_BY_DOCUMENT_FAILURE: {
        return {
            ...state,
            sections: []
        };
    }
    case GET_SECTIONS_BY_DOCUMENT_SUCCESS: {
        return {
            ...state,
            sections: action.data
        };
    }
    case GET_STATES_BY_COUNTRY_REQUEST: {
        return { ...state };
    }
    case GET_STATES_BY_COUNTRY_SUCCESS: {
        return {
            ...state,
            states: action.data
        };
    }
    case GET_STATES_BY_COUNTRY_FAILURE: {
        return {
            ...state,
            states: []
        };
    }
    case CHANGE_STATE: {
        return {
            ...state,
            selectedState: action.state,
            states: modifyCollection(state.states, 'key', action.state),
            documents: [],
            selectedPublication: '',
            selectedSection: '',
            selectedProductId: DEFAULT_DROPDOWN_ID_INT,
            curriculumAlignmentDocuments: {},
            selectedDocument: '',
            currentView: 'sectionList'
        };
    }
    case CHANGE_PUBLICATION: {
        return {
            ...state,
            selectedPublication: action.publicationId,
            selectedSection: '',
            documents: [],
            publications: modifyCollection(state.publications, 'key', action.publicationId),
            selectedProductId: DEFAULT_DROPDOWN_ID_INT,
            curriculumAlignmentDocuments: {},
            currentView: 'sectionList'
        };
    }
    case CHANGE_DOCUMENT: {
        return {
            ...state,
            selectedDocument: action.documentId,
            documents: modifyCollection(state.documents, 'id', action.documentId),
            currentView: 'sectionList'
        };
    }
    case CHANGE_SECTION: {
        return {
            ...state,
            selectedSection: action.sectionId
        };
    }
    case LOAD_SECTION_LIST: {
        return {
            ...state,
            currentView: 'sectionList'
        };
    }
    case GET_SECTION_DETAIL_BY_ID_REQUEST: {
        return {
            ...state,
            selectedSection: action.sectionId,
            currentView: 'sectionDetail' };
    }
    case GET_SECTION_DETAIL_BY_ID_SUCCESS: {
        return {
            ...state,
            selectedSectionDetail: convertToTreeData(action.data)
        };
    }
    case GET_SECTION_DETAIL_BY_ID_FAILURE: {
        return {
            ...state,
            selectedSectionDetail: {}
        };
    }
    case UPDATE_TREE_DATA: {
        return {
            ...state,
            selectedSectionDetail: { nodes: state.selectedSectionDetail.nodes, version: Math.random() }
        };
    }
    case REGISTER_MASTER_COURSE_REQUEST: {
        return { ...state, disableRegisterCourseButton: true };
    }
    case REGISTER_MASTER_COURSE_SUCCESS: {
        return {
            ...state,
            disableRegisterCourseButton: false
        };
    }
    case REGISTER_MASTER_COURSE_FAILURE: {
        return {
            ...state,
            disableRegisterCourseButton: false
        };
    }
    case CHANGE_CURRICULUM_TYPE: {
        return {
            ...state,
            selectedPublication: '',
            selectedDocument: '',
            selectedSection: '',
            curriculumType: action.curriculumCode,
            selectedCountry: '',
            selectedState: '',
            selectedProductId: DEFAULT_DROPDOWN_ID_INT,
            curriculumAlignmentDocuments: {},
            documents: [],
            publications: [],
            states: [],
            sections: []
        };
    }
    case GET_PUBLICATIONS_SUCCESS: {
        return {
            ...state,
            publications: action.data
        };
    }
    case UPDATE_PUBLICATIONS: {
        return {
            ...state,
            publications: action.publications
        };
    }
    case CHECK_SECTION_FILE_REQUEST:
    case CHECK_SECTION_FILE_FAILURE: {
        return {
            ...state,
            curriculumAlignmentDocuments: initState.curriculumAlignmentDocuments,
            isRequesting: false
        };
    }
    case CHECK_SECTION_FILE_SUCCESS: {
        const { alignmentDocumentName } = action;
        const {
            documents,
            selectedDocument,
            selectedPublication,
            selectedSection,
            publications,
            sections
        } = state;
        const publicationName = publications.find(item => item.id === selectedPublication).name;
        const document = documents.find(item => item.id === selectedDocument);
        const updatedDocumentName = `${document.name} (${document.adoptionYear})`;
        const currentSection = sections.find(item => item.id === selectedSection);
        const sectionName = currentSection.name;
        const sectionYearGroups = currentSection.yearGroups;

        return {
            ...state,
            curriculumAlignmentDocuments: getCurriculumAlignmentDocuments({
                alignmentDocumentName,
                documentName: updatedDocumentName,
                initialValue: initState.curriculumAlignmentDocuments,
                publicationName,
                sectionName,
                sectionYearGroups
            })
        };
    }
    case CHANGE_PRODUCT: {
        return {
            ...state,
            selectedProductId: action.productId,
            curriculumAlignmentDocuments:
                action.productId === DEFAULT_DROPDOWN_ID_INT ? {} : state.curriculumAlignmentDocuments
        };
    }
    case UPLOAD_SECTION_FILE_REQUEST: {
        return {
            ...state,
            isRequesting: true,
            isUploadingFile: true
        };
    }
    case UPLOAD_SECTION_FILE_SUCCESS: {
        return {
            ...state,
            isRequesting: false,
            isUploadingFile: false
        };
    }
    case DELETE_SECTION_FILE_REQUEST: {
        return {
            ...state,
            isRequesting: true
        };
    }
    case DELETE_SECTION_FILE_FAILURE:
    case DELETE_SECTION_FILE_SUCCESS: {
        return {
            ...state,
            curriculumAlignmentDocuments: initState.curriculumAlignmentDocuments,
            isRequesting: false
        };
    }
    default:
        return { ...state };
    }
}



// WEBPACK FOOTER //
// ./app/containers/curriculum-list/reducer.js